module.exports = __webpack_public_path__ + "4c796883.svg";